import app from '@devices/settings/device_settings/app.js';
import device_information from '@devices/settings/device_settings/device_information';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'ShellyBLUMotionZB',
	friendly_name: 'BLU Motion ZB',
	category: 'sensor',
	family: 'sensor',
	isPM: false,
	modes: {
		sensor: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['device_problem', 'lowBattery'],
			charts: false,
			bluetooth_settings: [
				{ title: 'motion_led', component: 'motion_led_ble' },
				{ title: 'beacon_mode', component: 'beacon_ble' },
				{ title: 'zigbee', component: 'zigbee_ble', min_ver: '1.2.12' },
				{ title: 'security', component: 'security_ble' },
			],
			settings: [
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'sensitivity', component: 'motion_sensitivity_ble' },
						{ title: 'blind_time', component: 'motion_blind_time_ble' },
						{
							title: 'bright_threshold',
							component: 'bright_threshold_ble',
						},
						{
							title: 'dark_threshold',
							component: 'dark_threshold_ble',
						},
						{ title: 'firmware_version', component: 'firmware_update_ble' },
						{ title: 'factory_reset', component: 'factory_reset_ble' },
					],
				},
				device_information,
			],
		},
	},
};
